var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"w-100 text-start flex-grow-1",attrs:{"tag":"article","bg-variant":_vm.order.status == 'new'
      ? 'success'
      : _vm.order.status == 'cancel'
      ? 'danger'
      : _vm.order.status == 'closed'
      ? 'secondary'
      : _vm.order.status == 'freeze'
      ? 'info'
      : 'light',"text-variant":"dark"}},[_c('b-card-text',{staticClass:"row mb-0",class:_vm.order.status == 'new' || _vm.order.status == 'active'
        ? 'text-dark'
        : 'text-light'},[_c('b-col',{staticClass:"h4",attrs:{"md":"6"}},[_vm._v(_vm._s(_vm.order.room_number))]),_c('b-col',{staticClass:"small text-end",attrs:{"md":"6"}},[_vm._v(_vm._s(_vm.orderCoast))])],1),_c('b-card-text',{staticClass:"text-muted row mb-0 h6"},[_c('b-col',{class:_vm.order.status == 'new' || _vm.order.status == 'active'
          ? 'text-dark'
          : 'text-light',attrs:{"md":"4"}},[(_vm.manager)?_c('span',[_vm._v(_vm._s(_vm.manager.login))]):_c('b-icon-dash')],1),_c('b-col',{attrs:{"md":"4"}},[_vm._v(_vm._s(_vm.date_create_order))]),_c('b-col',{staticClass:"text-end",attrs:{"md":"4"}},[(_vm.date_closed_order)?_c('span',[_vm._v(_vm._s(_vm.date_closed_order))]):_c('b-icon-dash')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }